import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../../components/common/Title/Title";
import { HiTag } from "react-icons/hi";
import { Tabs } from "antd";
import { initCampaignFilter, TAB } from "./constants";
import LoanCampaign from "./components/LoanCampaign";
import { convertLoanCampaign } from "../helpers/convertLoanCampaign";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Cookies from "js-cookie";
import Config from "../../../components/axios/Config";
import ExtensionCampaign from "./components/ExtensionCampaign";
import { convertExtensionCampaign } from "../helpers/convertExtensionCampaign";
import qs from "qs";
import ChooseOutletDialog from "../../finance/components/ChooseOutletDialog";
import { convertOutletList } from "../helpers";
import httpclient from "../../../components/httpclient";
import LoanInstallment from "./components/LoanInstallment";

const TabPane = Tabs.TabPane;

export default function Campaign(props) {
  const [tabState, setTabState] = useState(TAB.LOAN);
  const [loanCampaign, setLoanCampaign] = useState([]);
  const [extensionCampaign, setExtensionCampaign] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [lastpage, setLastPage] = useState(0);
  const [modalAdd, setModalAdd] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [categoryTotal, setCategoryTotal] = useState(0);
  const [outletTotal, setOutletTotal] = useState(0);
  const [campaignFilterInput, setCampaignFilterInput] =
    useState(initCampaignFilter);
  const [loanCampaignPagination, setLoanCampaignPagination] = useState({});
  const [extensionCampaignPagination, setExtensionCampaignPagination] =
    useState({});
  const [modalOutlet, setModalOutlet] = useState(false);
  const [outletList, setOutletList] = useState([]);

  const [outletCheckedList, setOutletCheckedList] = useState([]);
  const [indeterminate, setIndeterminate] = useState(false);
  const [outletCheckAll, setOutletCheckAll] = useState(false);

  const handleTabChange = (key) => {
    setTabState(key);
  };

  useEffect(() => {
    if (props?.location?.state?.list) {
      setTabState(props?.location?.state?.list)
    }
  }, []);

  useEffect(() => {
    if (tabState === TAB.EXTENSION) {
      getDataExtension();
    }
  }, [outletTotal, categoryTotal, tabState, campaignFilterInput]);

  useEffect(() => {
    if (tabState === TAB.LOAN || tabState === TAB.LOAN_INSTALLMENT) {
      getDataLoan();
    }
  }, [outletTotal, categoryTotal, tabState, campaignFilterInput]);

  useEffect(() => {
    getOutlet();
    getCategory();
  }, []);

  const handleTableChange = (pagination, _, sorter) => {
    setCampaignFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
            ? "DESC"
            : null,
    }));
  };

  const handleEnter =
    (type = "enter") =>
      (event) => {
        const { name, value } = event.target;
        if (event.keyCode === 13 || type === "blur") {
          setCampaignFilterInput((prev) => ({
            ...prev,
            [name]: value === "" && name === "pageSize" ? 10 : value,
            page: 1,
          }));
        }
      };

  const getCategory = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setCategoryTotal(response.data.data.total_item);
      }
    );
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletTotal(response.data.data.length);
        setOutletList(convertOutletList(response.data.data));

        const outletListId = response.data.data.items.map((outlet) => {
          return outlet.id;
        });

        setOutletCheckedList(outletListId);
        setIndeterminate(false);
        setOutletCheckAll(true);
      }
    );
  };

  const getDataLoan = () => {
    setLoading(true);
    let data = {
      page: parseInt(campaignFilterInput.page),
      size: parseInt(campaignFilterInput.pageSize),
      sorting_field: campaignFilterInput.sortingField,
      sorting_order: campaignFilterInput.sortingOrder,
      name: campaignFilterInput.name,
      outlet_id: campaignFilterInput.outlets,
      payment_type: tabState === TAB.LOAN ? 'balloon_payment' : tabState === TAB.LOAN_INSTALLMENT ? 'installment' : null
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}promo-loan`;

    httpclient.GET(url, data).then((response) => {
      setLoading(false);
      setTotalRecords(response.data.data.total_item);
      setLoanCampaign(
        convertLoanCampaign(
          response.data.data.items,
          outletTotal,
          categoryTotal
        )
      );
      setLoanCampaignPagination({
        current: response.data.data.page,
        pageSize: response.data.data.per_page,
        total: response.data.data.total_item,
      });
    });
  };

  const getDataExtension = () => {
    setLoading(true);

    let data = {
      page: parseInt(campaignFilterInput.page),
      size: parseInt(campaignFilterInput.pageSize),
      sorting_field: campaignFilterInput.sortingField,
      sorting_order: campaignFilterInput.sortingOrder,
      name: campaignFilterInput.name,
      outlet_id: campaignFilterInput.outlets,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}promo-extension`;

    httpclient.GET(url, data).then((response) => {
      setLoading(false);
      setTotalRecords(response.data.data.total_item);
      setExtensionCampaign(
        convertExtensionCampaign(
          response.data.data.items,
          outletTotal,
          categoryTotal
        )
      );
      setExtensionCampaignPagination({
        current: response.data.data.page,
        pageSize: response.data.data.per_page,
        total: response.data.data.total_item,
      });
    });
  };

  const handleOutletSave = () => {
    setCampaignFilterInput((prev) => ({
      ...prev,
      outlets: outletCheckedList,
      page: 1,
    }));
    setModalOutlet(false);
  };

  const handleCancel = () => {
    setModalOutlet(false);
  };

  const handleOutletCheckAllChange = (event) => {
    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    setOutletCheckedList(event.target.checked ? outletListId : []);
    setIndeterminate(false);
    setOutletCheckAll(event.target.checked);
  };

  const handleSingleOutletChange = (list) => {
    setOutletCheckedList(list);
    setIndeterminate(!!list.length && list.length < outletList.length);
    setOutletCheckAll(list.length === outletList.length);
  };

  const handleOutletButtonClick = () => {
    setModalOutlet(true);
  };

  return (
    <div className="px-3">
      <div className="py-4 d-flex justify-content-between">
        <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Promo"} />
          <Breadcrumb current={"Promo"} />
        </div>
        <div className="d-flex justify-content-end">
          <div
            style={{
              display: "flex",
              border: "1px solid #DCDCDC",
              borderRadius: 5,
              height: 50,
              width: 222,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: 18,
                color: "#303030",
              }}
            >
              <HiTag style={{ margin: 5, fontSize: 24, color: "#D6D6D6" }} />
              <span style={{ fontWeight: 700 }}>{totalRecord}</span> Total Promo
            </div>
          </div>
        </div>
      </div>

      <Tabs
        defaultActiveKey={
          props?.location?.state?.list === "loan_installment"
            ? TAB.LOAN_INSTALLMENT : props?.location?.state?.list === "extension"
              ? TAB.EXTENSION
              : TAB.LOAN
        }
        onChange={handleTabChange}
      >
        <TabPane tab="Pinjaman Balloon Payment" key={TAB.LOAN}>
          <LoanCampaign
            handleOutletButtonClick={handleOutletButtonClick}
            data={loanCampaign}
            handleEnter={handleEnter}
            loading={loading}
            getData={getDataLoan}
            tablePagination={loanCampaignPagination}
            handleTableChange={handleTableChange}
          />
        </TabPane>
        <TabPane tab="Pinjaman Cicilan" key={TAB.LOAN_INSTALLMENT}>
          <LoanInstallment
            handleOutletButtonClick={handleOutletButtonClick}
            handleEnter={handleEnter}
            handleTableChange={handleTableChange}
            tablePagination={loanCampaignPagination}
            data={loanCampaign}
            loading={loading}
            getData={getDataLoan}
          />
        </TabPane>
        <TabPane tab="Perpanjangan" key={TAB.EXTENSION}>
          <ExtensionCampaign
            handleOutletButtonClick={handleOutletButtonClick}
            handleEnter={handleEnter}
            data={extensionCampaign}
            loading={loading}
            tablePagination={extensionCampaignPagination}
            getData={getDataExtension}
            handleTableChange={handleTableChange}
          />
        </TabPane>
      </Tabs>

      <ChooseOutletDialog
        title={"Pilih Cabang/Outlet"}
        visible={modalOutlet}
        handleSave={handleOutletSave}
        handleCancel={handleCancel}
        data={outletList}
        onCheckAllChange={handleOutletCheckAllChange}
        onSingleChange={handleSingleOutletChange}
        indeterminate={indeterminate}
        outletCheckAll={outletCheckAll}
        outletCheckedList={outletCheckedList}
      />
    </div>
  );
}
